import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {SelectFieldConfig} from '../select-field.config';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';

@Component({
    selector: 'mydocma-form-select-field',
    templateUrl: './select-field.component.html',
    styleUrls: ['./select-field.component.scss']
})
export class SelectFieldComponent extends BaseFieldComponent<SelectFieldConfig> implements OnInit {

    public readonly staticCssClass = 'mydocma-select-field';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher, element, renderer);
    }

    /**
     * Lifecycle hook that is called after data-bound properties of a directive are initialized.
     */
    public async ngOnInit() {
        super.ngOnInit();

        await this.setSelect();
    }

    public async setSelect() {
        if ((this.fieldWrapper.config as SelectFieldConfig).getSource) {
            this.fieldWrapper.source = await (this.fieldWrapper.config as SelectFieldConfig).getSource();

            return;
        }

        this.fieldWrapper.source = (this.fieldWrapper.config as SelectFieldConfig).source;
    }

    public async onFieldWrapperUpdated() {
        super.onFieldWrapperUpdated();

        await this.setSelect();
    }

    public onClick() {
        super.onControlClick();
    }
}
